import { colors } from '@aloft/toolkit-sui';

type Props = { size?: number };

export const DefaultFiltersInfoIcon = ({ size = 32 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    fillRule="nonzero"
  >
    <path
      d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20Z"
      fill="#3182CE"
    />
    <path
      d="M9 9V15H11V9H9ZM9 5V7H11V5H9Z"
      fill={colors.textOffset}
    />
  </svg>
);
